/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

require("./src/styles/global.css")
require("./node_modules/bootstrap/dist/css/bootstrap.css")
